import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { FolderEmptyItem } from "src/components/Folders/FolderEmptyItem";
import { FolderItemsSection } from "src/components/Folders/FolderItemsSection";
import { FolderSelectionCheckbox } from "src/components/Folders/FolderSelectionCheckbox";
import type { FolderPreviewProps } from "src/components/Folders/types";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import CourseView from "src/components/NewComponents/Views/ScoreViews/CourseView";

export const FolderCoursesPreview = ({
	folderId,
	folderName,
	items,
	isSelectMode,
	selectedItems,
	toggleSelection,
}: FolderPreviewProps) => {
	const { t } = useTranslation();
	const { openModal } = useModals();

	return (
		<FolderItemsSection
			title={t("folder.tabs.courses", "Kursy")}
			type="course"
			folderId={folderId}
			isVisible={true}
		>
			{items?.map((item) => {
				const isSelected =
					isSelectMode &&
					selectedItems?.some(
						(i) => i.itemId === item.data?.id && i.itemType === "course",
					);

				return (
					<div
						key={item.id}
						data-test-id="folder-course-item"
						data-course-id={item.data?.id}
						onClick={
							isSelectMode
								? () => toggleSelection(item.data, "course", item.id)
								: undefined
						}
						className={cx(isSelectMode && "cursor-pointer p-relative")}
					>
						{isSelectMode && (
							<FolderSelectionCheckbox isSelected={!!isSelected} />
						)}
						<CourseView
							row={item.data}
							className={cx(
								"mb-0 w-100 min-w-350",
								isSelected && "border-color-primary",
								isSelectMode && "pointer-events-none",
							)}
						/>
					</div>
				);
			})}
			{(items?.length ?? 0) < 3 && (
				<FolderEmptyItem
					onClick={() => {
						openModal(ModalsNames.AddFolderContentModal, {
							folderId,
							folderName,
							initialTab: "course",
						});
					}}
				/>
			)}
		</FolderItemsSection>
	);
};
